import {AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';
import {RouterLink} from "@angular/router";
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-offer-banner',
  templateUrl: './offer-banner.component.html',
  styleUrls: ['./offer-banner.component.scss'],
  standalone: true,
  imports: [
    RouterLink, NgIf
  ]
})
export class OfferBannerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('stickyElement') stickyElement!: ElementRef;
  private observer?: IntersectionObserver;

  ngAfterViewInit() {
    if (this.sticky) {
      this.setupStickyBehavior();
    }
  }

  private setupStickyBehavior() {
    const footer = document.querySelector('app-footer');
    if (footer) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (this.stickyElement?.nativeElement) {
            if (entry.isIntersecting) {
              // Footer is visible, make element absolute
              this.stickyElement.nativeElement.style.position = 'absolute';
              this.stickyElement.nativeElement.style.bottom = (footer as HTMLElement).offsetHeight + 'px';
            } else {
              // Footer not visible, keep sticky
              this.stickyElement.nativeElement.style.position = 'sticky';
              this.stickyElement.nativeElement.style.bottom = '10px';
            }
          }
        });
      });
      this.observer.observe(footer);
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  @Input() title: string = "Get Started";
  @Input() description: string = "Get Started With <strong>50% OFF</strong> Your First Week";
  @Input() additionalDescription: string = "<strong>+ FREE DELIVERY</strong>, then <strong>30% OFF</strong> Every Week After";
  @Input() link: string;
  @Input() showAsBar: boolean = false;
  @Input() sticky: boolean = true;
    
}
